import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-w-full tw-my-md"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "sr-only",
  id: "activeFiltersTitle"
}, "Active Filters:", -1 /* HOISTED */)
const _hoisted_3 = {
  class: "tw-py-md tw-flex tw-flex-wrap tw-gap-md",
  "aria-labelledby": "activeFiltersTitle"
}
const _hoisted_4 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Active Filters "),
    (_ctx.activeFilters.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeFilters, (filter) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "tw-w-auto",
                key: filter.name
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.toggleFilterOption(filter)),
                  class: "btn-collection-tag",
                  "aria-label": `Applied Filter: ${filter.name}. Click to remove`
                }, _toDisplayString(filter.name), 9 /* TEXT, PROPS */, _hoisted_4)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" / Active Filters ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}